var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortArrowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.866,
    height: 44.336,
    viewBox: "0 0 31.866 44.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sort-arrows-icon",
    d: "M3.871,29.736H30.376A2.676,2.676,0,0,1,32.27,34.3L19.017,47.555a2.662,2.662,0,0,1-3.775,0L1.978,34.3A2.676,2.676,0,0,1,3.871,29.736Zm28.4-11.694L19.017,4.789a2.662,2.662,0,0,0-3.775,0L1.978,18.042a2.676,2.676,0,0,0,1.893,4.566H30.376A2.676,2.676,0,0,0,32.27,18.042Z",
    transform: "translate(-1.191 -4.004)",
    fill: "#5046e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrowsIcon);
export default __webpack_public_path__ + "static/media/sort-arrows-icon.5adb3f91a8bd964e7b3f927b73199348.svg";
export { ForwardRef as ReactComponent };